import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import striptags from 'striptags';

function truncateDesc(props) {
  const str = props.description || '';
  const cleanedDescription = striptags(str, [
    'a',
    'b',
    'em',
    'i',
    'u',
    'strike',
    'strong'
  ]);

  const descriptionPieces = cleanedDescription.split('. ');

  if (descriptionPieces.length >= 2) {
    return descriptionPieces.slice(0, 2).join('. ');
  }
  return descriptionPieces;
}

export default function Author(props) {
  if (!props.description) {
    return null;
  }

  return (
    <div className={`author author--${props.modifier}`}>
      <h4 className="author__title">About the author</h4>
      {/* eslint-disable */}
      <p className="author__description" dangerouslySetInnerHTML={{ __html: truncateDesc(props) }} />
      <p className="author__description"> <Link className="author__bio-page" to={`/user/${props.slug}`}>More</Link></p>
      {/* eslint-enable */}
    </div>
  );
}

Author.propTypes = {
  modifier: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
